import { RemovedOption } from "src/pages/configurator/calcSelectedOptionIds";
import { Css } from "~generated/css";
import { pluralize, useTestIds } from "~utils";
import { Icon } from "../atoms";
import { DebugText } from "./DebugText";
import { IconTooltip } from "./IconTooltip";

export function ConflictTooltip(props: { conflicts: RemovedOption[]; optionName: string; isAlreadySelected: boolean }) {
  const { conflicts, optionName, isAlreadySelected } = props;
  // We need to create a unique ID based on the option name to prevent duplicate tooltips
  const tid = useTestIds(props, `conflictTag_${optionName}`);

  const actionText = isAlreadySelected ? "Removing" : "Selecting";

  return (
    <IconTooltip
      {...tid.conflictTooltip}
      type="warning"
      title={
        <div css={Css.t12.white.df.gap1.aic.$}>
          <Icon name="warning-icon-small" /> Option Conflict
        </div>
      }
      message={
        <div css={Css.t10.white.$}>
          <DebugText>{conflicts.map((c) => c.displayName + " " + c.id).join(", ")}</DebugText>
          {`${actionText} this ${optionName} will remove the ${conflicts.map((c) => c.displayName).join(", ")} ${pluralize(
            conflicts.length,
            "option",
          )} due to conflicts or dependencies.`}
        </div>
      }
    />
  );
}
